import { StaticContent } from '../components/Questions/FeaturesAndBenefits';

import Boardroom from '../assets/features-images/business/1.png';
import ReceiptDispatchService from '../assets/features-images/business/3.png';
import Trailer from '../assets/features-images/personal/1.png';
import TruckPalletJack from '../assets/features-images/personal/2.jpg';
import PalletJack from '../assets/features-images/personal/3.png';
import Undercover from '../assets/features-images/personal/4.jpg';
import RubbishDisposal from '../assets/features-images/personal/5.jpg';
import VehicleStorage from '../assets/features-images/personal/6.jpg';
import CCTV from '../assets/features-images/personal/7.jpg';
import GroundFloor from '../assets/features-images/personal/8.jpg';
import Merchandise from '../assets/features-images/personal/9.jpg';
import Van from '../assets/features-images/personal/10.jpg';

export interface StaticLocations {
    [key: string]: StaticContent[];
}
export const ASH: StaticLocations = {
    business: [
        {
            name: 'Receipt/Dispatch Service',
            image: ReceiptDispatchService,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Boardroom For Use',
            image: Boardroom,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Truck/Forklift/Pallet Jack',
            image: TruckPalletJack,
            description: 'PLACEHOLDER TEXT',
        },
    ],
    personal: [
        {
            name: 'Free Move-In Truck',
            image: TruckPalletJack,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Undercover Individual Secured Storage',
            image: Undercover,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Industry Experienced Staff',
            image: ReceiptDispatchService,
            description: 'PLACEHOLDER TEXT',
        },
    ],
};

export const GEP: StaticLocations = {
    business: [
        {
            name: 'Receipt/Dispatch Service',
            image: ReceiptDispatchService,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Drive up Noke units',
            image: Undercover,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Rubbish Disposal',
            image: RubbishDisposal,
            description: 'PLACEHOLDER TEXT',
        },
    ],
    personal: [
        {
            name: 'Free Move-In Trailer',
            image: Trailer,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Ground Floor Access',
            image: Undercover,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Vehicle Storage',
            image: VehicleStorage,
            description: 'PLACEHOLDER TEXT',
        },
    ],
};

export const LON: StaticLocations = {
    business: [
        {
            name: 'Receipt/Dispatch Service',
            image: ReceiptDispatchService,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Security; CCTV, Electric Perimeter Fencing',
            image: CCTV,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Forklift/Pallet Jack',
            image: PalletJack,
            description: 'PLACEHOLDER TEXT',
        },
    ],
    personal: [
        {
            name: 'Free Move-In Truck/Trailer',
            image: TruckPalletJack,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Ground Floor/Easy Access',
            image: GroundFloor,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Merchandise and Packing Aids On Site',
            image: Merchandise,
            description: 'PLACEHOLDER TEXT',
        },
    ],
};

export const MEL: StaticLocations = {
    business: [
        {
            name: 'Receipt/Dispatch Service',
            image: ReceiptDispatchService,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Rubbish Disposal',
            image: RubbishDisposal,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Forklift/Pallet Jack',
            image: PalletJack,
            description: 'PLACEHOLDER TEXT',
        },
    ],
    personal: [
        {
            name: 'Free Move-In Van',
            image: Van,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Ground Floor/Easy Access',
            image: GroundFloor,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Trolleys Available For Use',
            image: PalletJack,
            description: 'PLACEHOLDER TEXT',
        },
    ],
};

export const BAR: StaticLocations = {
    business: [
        {
            name: 'Receipt/Dispatch Service',
            image: ReceiptDispatchService,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Boardroom',
            image: Boardroom,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Rubbish Disposal',
            image: RubbishDisposal,
            description: 'PLACEHOLDER TEXT',
        },
    ],
    personal: [
        {
            name: 'Free Move-In Truck/Trailer',
            image: TruckPalletJack,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Merchandise and Packing Aids On Site',
            image: Merchandise,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: '5am-10pm Access',
            image: CCTV,
            description: 'PLACEHOLDER TEXT',
        },
    ],
};

export const NOR: StaticLocations = {
    business: [
        {
            name: 'Receipt/Dispatch Service',
            image: ReceiptDispatchService,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Free Move-In Trailer',
            image: Trailer,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Forklift/Pallet Jack/Trolleys',
            image: PalletJack,
            description: 'PLACEHOLDER TEXT',
        },
    ],
    personal: [
        {
            name: 'Free Move-In Trailer',
            image: Trailer,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Trolleys & Pallet Jack Available For Use',
            image: PalletJack,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Undercover Individual Secured Storage',
            image: Undercover,
            description: 'PLACEHOLDER TEXT',
        },
    ],
};

export const PAR: StaticLocations = {
    business: [
        {
            name: 'Forklift Service',
            image: PalletJack,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Rubbish Disposal',
            image: RubbishDisposal,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: '5am-10pm Access',
            image: CCTV,
            description: 'PLACEHOLDER TEXT',
        },
    ],
    personal: [
        {
            name: 'Free Move-In Truck/Trailer',
            image: Trailer,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: '5am-10pm Access',
            image: CCTV,
            description: 'PLACEHOLDER TEXT',
        },
        {
            name: 'Trolleys Available For Use',
            image: PalletJack,
            description: 'PLACEHOLDER TEXT',
        },
    ],
};
